import CreatorCodePromotions from "./CreatorCodePromotions";
export default CreatorCodePromotions;
